import type { ClawAccess } from '@/app/hooks';
import type { SessionMode } from '../../types';

interface DeriveChatInputStateOptions {
  access: ClawAccess | null;
  activeClawId?: string | null;
  activeClawStatus?: string | null;
  activeSessionId: string | null;
  activeSessionMode?: SessionMode;
  isSending: boolean;
  applyingForViduClaw: boolean;
}

interface DerivedChatInputState {
  isReady: boolean;
  showChatInput: boolean;
  disableChatInputSend: boolean;
  disableChatInputUpload: boolean;
  chatInputSending: boolean;
  chatInputYoloActive: boolean | undefined;
}

export const deriveChatInputState = ({
  access,
  activeClawId,
  activeClawStatus,
  activeSessionId,
  activeSessionMode,
  isSending,
  applyingForViduClaw,
}: DeriveChatInputStateOptions): DerivedChatInputState => {
  const isReady = access === 'ready' && !!activeClawId && activeClawStatus === 'CLAW_STATUS_ACTIVE';
  const showChatInput = access !== null;
  const disableChatInputSend = access === null;
  const disableChatInputUpload = access === null;
  const chatInputSending = isReady ? isSending : applyingForViduClaw;
  const chatInputYoloActive = activeSessionId ? activeSessionMode === 'yolo' : undefined;

  return {
    isReady,
    showChatInput,
    disableChatInputSend,
    disableChatInputUpload,
    chatInputSending,
    chatInputYoloActive,
  };
};
